<template>
  <div :id="id" class="isis-page">
    <div class="isis-page__header m-0 md-layout">
      <div class="md-layout-item mb-5">
        <span class="nav-link text-lg lg:text-2xl" @click="backNavigation">
          <i class="fas fa-chevron-left"></i>
          <span>{{ name ? `${$t(title)}: ${name}` : $t(title) }}</span>
        </span>
      </div>
    </div>

    <!-- PAGE CONTENT -->
    <slot></slot>
    <!-- PAGE CONTENT -->
  </div>
</template>

<script>
import { goToPreviousPage } from "@/helpers/utils";

export default {
  name: "isis-page-layout",
  props: ["id", "title", "navigateFunc", "name"],
  data() {
    return {};
  },
  methods: {
    backNavigation() {
      if (this.navigateFunc) {
        this.navigateFunc();
        return;
      }

      goToPreviousPage(this.$router);
    }
  }
};
</script>
